module.exports = __webpack_public_path__ + "static/media/doc.658ad331.png";